import React from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import requestSuggestions from '../../data/requestSuggestion'
import { t } from 'i18next'
import i18n from '../../i18n'
import { createRequest } from '../../store/actions/requestsAction'
import { ActivityIndicator } from 'react-native-web'

function RequestModal({ toggleModal, requestType, data }) {
    const requests = requestSuggestions(requestType)
    const [customLabel, setCustomLabel] = React.useState('')
    const [suggestedLabelId, setSuggestedLabelId] = React.useState()
    const [moreDetails, setMoreDetails] = React.useState('')
    const language = i18n.language
    const [loading, setLoading] = React.useState(false)
    const onChangeCustomLabel = (e) => {
        if (suggestedLabelId === undefined) {
            //!clear suggested label in e.target.value
            setCustomLabel(e.target.value)
        } else {
            setCustomLabel('')
        }
        setSuggestedLabelId()
    }

    const onClickSuggestedLabel = (suggestedLabel) => {
        setSuggestedLabelId(suggestedLabel)
        setCustomLabel(t(requests.find((a) => a.id === suggestedLabel).label))
    }

    const onSend = async () => {
        const request = {
            label: customLabel,
            moreDetails,
            labelId: suggestedLabelId,
            centerId: JSON.parse(localStorage.getItem('centerId')).centerId,
            adminId: JSON.parse(localStorage.getItem('Auth')).user._id,
            requestType,
            status: 0,
            data,
        }
        setLoading(true)
        await createRequest(request)
        toggleModal()
        setLoading(false)
    }
    return (
        <div style={{ direction: language === 'en' ? 'ltr' : 'rtl' }} className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50" >
            <div className="p-4 bg-white rounded-lg" style={{ width: 500, height: 'auto' }}>
                <div className="flex justify-end">
                    <AiOutlineCloseCircle color='red' onClick={loading ? null : toggleModal} className="cursor-pointer" size={22} />
                </div>


                <div className='flex items-center w-full mt-2' >
                    <div className="w-1/3 mr-1 font-bold">
                        {t('request')}
                    </div>
                    <div className='w-full ' >
                        <input value={customLabel} onChange={onChangeCustomLabel} placeholder={t('request')} className="w-full p-2 border rounded-lg" />
                    </div>
                </div>
                <div className='flex my-7' >
                    <h1 className='mx-1' >{t('orSuggestedRequest')}</h1>
                    <div className='flex flex-wrap ' >
                        {requests.map((rq, i) => {
                            return <Suggestion suggestedLabelId={suggestedLabelId} onClick={onClickSuggestedLabel.bind(this, rq.id)} rq={rq} key={i} />
                        })}
                    </div>
                </div>
                <div className='flex w-full my-2' >
                    <div className="w-1/3 mr-1 font-bold">
                        {t('moreDetails')}
                    </div>
                    <div className='w-full' >
                        <textarea value={moreDetails} style={{ resize: 'vertical', maxHeight: 100 }} onChange={(e) => setMoreDetails(e.target.value)} placeholder={t('moreDetails')} className="w-full p-2 border rounded-lg" />
                    </div>
                </div>

                <div className='flex justify-center my-3' >
                    <div onClick={onSend} className={`p-2 m-1 border bg-blue-400 text-white px-8 rounded-lg cursor-pointer`} >
                        {loading ? <ActivityIndicator color='#fff' /> : t('send')}
                    </div>
                </div>
            </div>
        </div >
    )
}

const Suggestion = ({ rq, onClick, suggestedLabelId }) => {
    return <div onClick={onClick} className={`p-1  m-1 opacity-70 border rounded-lg cursor-pointer ${suggestedLabelId === rq.id ? 'bg-green-500 opacity-100 text-white' : ''}`} >
        {t(rq.label)}
    </div>
}

export default RequestModal
